import Vue from 'vue'

export const Service = Vue.extend({})



// WEBPACK FOOTER //
// ./src/js/shared/services/base.js